module.exports = __webpack_public_path__ + "static/media/untied-white-logo.d560b830.png";